module.exports = __webpack_public_path__ + "static/WEDDING E&M-484-b5d56b04a77511e41cb305d8ccd347ce.jpg";